<template>
  <section class="admin-section" aria-labelledby="admin-actions-heading">
  <ReportsManagerSettingsList />
  </section>


</template>

<script>
import ReportsManagerSettingsList from "./ReportsManagerSettingsList";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";

export default {
  name: "ReportsManagerSettingsStage",
  components: {
    ReportsManagerSettingsList,
  },
  computed: {
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
  },
  data() {
    return {
      elementsEnabled: true,
      opacityStyle: "opacity:1;",
      underConstructionWarningDisplayed:true,
    };
  },
  methods: {},
  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-home-circle me-1"></i> Ustawienia Centralnych Raportów`)
  },
  created() {
    this.simplepharmAuth.refreshToken().then(()=>{
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    })
  },
};
</script>

<style scoped>
.settings-stage {
  padding-left: 16px;
  padding-right: 16px;
}
</style>
